import {Howl, Howler} from 'howler';

const sound = new Howl({
    src: ['https://stream-40.zeno.fm/q2cy34uf27zuv?zs=pzu9DLrIRoamNFNWLn6XDAstream']
});
  
sound.play();